module.exports = __webpack_public_path__ + "static/media/lego-education.dbc97915.svg";